import axios from "axios";

export const getTonUsdPrice = async (): Promise<number | undefined> => {
  try {
    const response = await axios.get(
      "https://tonapi.io/v2/rates?tokens=ton&currencies=usd"
    );

    const usdPrice = response.data?.rates?.TON?.prices?.USD;

    if (typeof usdPrice === "number") {
      return usdPrice;
    }

    return undefined;
  } catch (error) {
    return undefined;
  }
};
